import { Projects_Metadata_Bool_Exp } from '@/gql/generated/graphql'
import { getVerticalFilter } from '@utils/project'

export const constructFullTagFilter = (selectedTags: string[]): Projects_Metadata_Bool_Exp => {
  if (!selectedTags.length) return {}

  const tags = selectedTags?.map((tag) => {
    return {
      tags: {
        tag_name: {
          _eq: tag
        }
      }
    }
  })

  return {
    _or: tags
  }
}

export const constructVerticalFilter = (selectedVerticals: string[]): Projects_Metadata_Bool_Exp => {
  if (!selectedVerticals.length) return {}
  const verticals = selectedVerticals.map((vertical) => {
    return getVerticalFilter(vertical)
  })

  return {
    _or: verticals
  }
}

export const constructSeriesFilter = (selectedSeries: string[]): Projects_Metadata_Bool_Exp => {
  if (!selectedSeries.length) return {}

  const series = selectedSeries?.map((seriesName) => {
    return {
      tags: {
        tag_name: {
          _eq: seriesName
        }
      }
    }
  })

  return {
    _or: series
  }
}
